var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpdesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 21v-9h-8v9h-9v8h9v9h8v-9h9v-8h-9Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 29H4V16a4 4 0 0 1 4-4h13v17h-9Zm0 0v-4c0-2 2-4 4-4h5v8h-9Zm26-8h8v13a4 4 0 0 1-4 4H29V21h9Zm0 0v4c0 2-2 4-4 4h-5v-8h9Z",
    fill: "#1AD3BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12V4h13a4 4 0 0 1 4 4v13H21v-9Zm0 0h4c2 0 4 2 4 4v5h-8v-9Zm8 26v8H16a4 4 0 0 1-4-4V29h17v9Zm0 0h-4c-2 0-4-2-4-4v-5h8v9Z",
    fill: "#1A6F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpdesk);
export default __webpack_public_path__ + "static/media/Helpdesk.7e2fd169d1de4e0d2038e8c2550af3be.svg";
export { ForwardRef as ReactComponent };